import React, { useState } from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

import ganesh from '../assets/gallery/ganesh.png';
import brahma from '../assets/gallery/brahma.png';
import durga from '../assets/gallery/durga.png';
import lakshmi from '../assets/gallery/laxmi.png';
import saraswati from '../assets/gallery/saraswati.png';
import shiv from '../assets/gallery/shiv.png';
import vishnu from '../assets/gallery/vishnu.png';
import Carousel from './Carousel';

const Gallery = () => {
  const gallery = [
    {
      name: 'Lord Ganesh',
      description:
        'The remover of obstacles, representing wisdom and new beginnings.',
      image: ganesh,
    },
    {
      name: 'Maa Durga',
      description:
        'The fierce protector and symbol of strength, power, and motherhood.',
      image: durga,
    },
    {
      name: 'Lord Shiv',
      description:
        'The destroyer, embodying transformation and regeneration, and the source of all wisdom.',
      image: shiv,
    },
    {
      name: 'Lord Vishnu',
      description:
        'The preserver and protector of the universe, embodying compassion and balance.',
      image: vishnu,
    },
    {
      name: 'Lord Brahma',
      description:
        'The divine embodiment of the holy trinity, representing knowledge, devotion, and the path to enlightenment.',
      image: brahma,
    },
    {
      name: 'Lakshmi Maa',
      description:
        'Goddess of wealth, prosperity, and fortune, embodying grace and abundance.',
      image: lakshmi,
    },
    {
      name: 'Saraswati Maa',
      description:
        'Goddess of wisdom, learning, and the arts, symbolizing knowledge and creativity.',
      image: saraswati,
    },
  ];
  const [n, setN] = useState(4);

  return (
    <div className="py-10 w-[95%]">
      <div className="text-center">
        <h2 className="text-[40px] md:text-[60px] mt-[20px] font-abhaya mb-2 text-[#800000]">
          Darshan - Gallery
        </h2>
        <p className="font-afacad text-[30px] font-bold leading-[1.2] mt-[20px] mx-auto text-center tracking-wide text-[#800000]">
          Experience peace, strength, and divine blessings at Hanuman
          Mandir—your spiritual home in Jersey City.
        </p>
      </div>

      <div className="mt-8 max-h-full">
        <Carousel />
      </div>

      <div className="text-center mt-20">
        <p className="font-afacad text-[25px] font-bold leading-[1.2] mt-[20px] mx-auto text-center tracking-wide text-[#800000]">
          Shree Hanuman Mandir is a sacred sanctuary, home to Shree Hanuman and
          all Devi-Devtas of Sanatan Dharma
        </p>
      </div>

      <div className="w-full px-3 py-6">
        <div className="hidden md:grid grid-cols-1 md:grid-cols-3 lg:grid-cols-4 gap-6 w-full">
          <div className="relative col-span-1 row-span-2 rounded-[10px] group w-full cursor-pointer">
            <img
              src={gallery[0].image}
              alt="featured"
              className="w-full h-full object-cover rounded-[10px] shadow-lg"
            />
            <div className="absolute inset-0 bg-[#9B2912] bg-opacity-70 flex flex-col justify-center items-center opacity-0 transition-opacity duration-300 group-hover:opacity-100 rounded-[10px]">
              <h3 className="text-white text-lg font-bold mb-2">
                {gallery[0].name}
              </h3>
              <p className="text-white text-sm px-4 text-center">
                {gallery[0].description}
              </p>
            </div>
          </div>
          {gallery.slice(1).map((src, index) => (
            <div
              key={index}
              className="relative col-span-1 row-span-1 hover:scale-[1.05] cursor-pointer group overflow-hidden rounded-lg shadow-lg aspect-square"
            >
              <img
                src={src.image}
                alt={src.name}
                className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
              />
              <div className="absolute inset-0 bg-[#9B2912] bg-opacity-70 flex flex-col justify-center items-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                <h3 className="text-white text-lg font-bold mb-2">
                  {src.name}
                </h3>
                <p className="text-white text-sm px-4 text-center">
                  {src.description}
                </p>
              </div>
            </div>
          ))}
        </div>

        <div>
          <div className="mt-4 text-center md:hidden">
            <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4">
              {gallery.slice(0, n).map((obj, index) => (
                <div
                  key={index}
                  className="relative group overflow-hidden rounded-lg shadow-lg aspect-square"
                >
                  <img
                    src={obj.image}
                    alt={obj.name}
                    className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-110"
                  />
                  <div className="absolute inset-0 bg-[#9B2912] bg-opacity-70 flex flex-col justify-center items-center opacity-0 transition-opacity duration-300 group-hover:opacity-100">
                    <h3 className="text-white text-lg font-bold mb-2">
                      {obj.name}
                    </h3>
                    <p className="text-white text-sm px-4 text-center">
                      {obj.description}
                    </p>
                  </div>
                </div>
              ))}
            </div>
            <button
              onClick={() => setN(n === gallery.length ? 4 : gallery.length)}
              className="mt-[25px] px-4 py-2 bg-gradient-to-r from-[#E66526] to-[#BE3D23] text-white rounded-md focus:outline-none"
            >
              {n === gallery.length ? 'View Less' : 'View More'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Gallery;
